import { mutateApi, queryApi } from "src/utils/api/ApiMethods"
import { buildQueryString } from "src/utils/api/query_param_helpers"

export const getInquiries = (marinaSlug, params = {}) => {
  const qs = buildQueryString(params)
  return queryApi(`/manage/${marinaSlug}/leads${qs}`)
}

export const getInquiriesSelectableIds = (marinaSlug, params = {}) => {
  const qs = buildQueryString(params)
  return queryApi(`/manage/${marinaSlug}/leads/selectable_ids${qs}`)
}

export const printInquiries = async ({ marinaSlug, ids, ...params }) => {
  const response = await mutateApi({
    url: `/manage/${marinaSlug}/leads/print`,
    method: "POST",
    data: { ids, ...params },
  })
  return response.data
}

export const updateInquiryStatus = async (marinaSlug, { data }) => {
  return mutateApi({
    url: `/manage/${marinaSlug}/leads/${data.id}/update_status`,
    method: "POST",
    data: { status: data.status, decline_reason: data.declineReason },
  })
}

export const acceptToContractGroup = async (marinaSlug, { data }) => {
  return mutateApi({
    url: `/manage/${marinaSlug}/leads/${data.id}/accept`,
    method: "POST",
    data: { id: data.id, contract_group_id: data.contractGroupId },
  })
}
